// Module
var code = "<template><div class=\"padding-10 animation-slide-bottom\"></div></template>";
// Exports
module.exports = code;